import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const SET_CALLTRACKING_ENABLED = 'CALLTRACKING :: SET_CALLTRACKING_ENABLED';

export type TSetCalltrackingEnabledAction = IReduxAction<typeof SET_CALLTRACKING_ENABLED, boolean>;

export const setCalltrackingEnabled = actionGenerator<typeof SET_CALLTRACKING_ENABLED, boolean>(
  SET_CALLTRACKING_ENABLED,
);
